import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { ArrowUpIcon, ControlPointDuplicateIcon, GroupIcon, VisibilityFilledIcon } from '@change/ds-icons';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { usePromotionHistory } from './hooks/usePromotionHistory';

export const PromotionHistory: React.FC = () => {
	const { data } = usePromotionHistory();

	return (
		<div className="flex flex-col gap-6 px-4 md:px-12">
			<div className="flex items-center gap-1" id="petition-insights-title">
				<Text as="h3" className="text-size-heading-small">
					<Translate value="corgi.petition.starter_dashboard.petition_insights.promotion_history.title" />
				</Text>
				<InfoTooltip aria-describedby="petition-insights-title">
					<Translate
						value={`corgi.petition.starter_dashboard.petition_insights.promotion_history.tip${
							data.shouldUseDonationLanguage ? '_donation' : ''
						}`}
					/>
				</InfoTooltip>
			</div>

			<div className="flex flex-col flex-nowrap gap-4 md:flex-row md:flex-wrap md:gap-6">
				<div className="flex items-center gap-2">
					<ArrowUpIcon className="text-icon-information" size="x-small" />
					<Text as="span">
						<TranslatePlural
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.promoter"
							replacements={{ promoterCount: data.promoterCountFormatted }}
							count={data.promoterCount}
						/>
					</Text>
				</div>
				<div className="flex items-center gap-2">
					<ControlPointDuplicateIcon className="text-icon-information" />
					<Text as="span">
						<Translate
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.contributions"
							replacements={{ contributorCount: data.contributionsFormatted }}
						/>
					</Text>
				</div>
				<div className="flex items-center gap-2">
					<VisibilityFilledIcon className="text-icon-information" size="small" />
					<Text as="span">
						<TranslatePlural
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.petition_view"
							replacements={{ petitionViewCount: data.impressionsTotalFormatted }}
							count={data.impressionsTotal}
						/>
					</Text>
				</div>
				<div className="flex items-center gap-2">
					<GroupIcon className="text-icon-information" />
					<Text as="span">
						<TranslatePlural
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.signature"
							replacements={{ signatureCount: data.signatureCountFormatted }}
							count={data.signatureCount}
						/>
					</Text>
				</div>
			</div>
		</div>
	);
};
